var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{staticClass:"stat-card",attrs:{"hoverable":true}},[_c('a-statistic',{attrs:{"title":_vm.title,"value":_vm.text},scopedSlots:_vm._u([{key:"prefix",fn:function(){return [_c('a-icon',{attrs:{"type":_vm.icon}})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }